import React from 'react';
import {AbstractMapItem, MapInput} from '../MapItems/MapItems';
import './WDRIconItemSA.css';

function updateTempColor(temp) {
  const colorIndex = temp;

  let tempColor;

  if (colorIndex <= -15) {
    tempColor = '#75165B';
  } else if (colorIndex > -15 && colorIndex <= -10) {
    tempColor = '#00417B';
  } else if (colorIndex > -10 && colorIndex <= -5) {
    tempColor = '#006E9F';
  } else if (colorIndex > -5 && colorIndex <= 0) {
    tempColor = '#28A5A7';
  } else if (colorIndex > 0 && colorIndex <= 5) {
    tempColor = '#6AB165';
  } else if (colorIndex > 5 && colorIndex <= 12) {
    tempColor = '#A0C300';
  } else if (colorIndex > 12 && colorIndex <= 20) {
    tempColor = '#F49500';
  } else if (colorIndex > 20 && colorIndex <= 25) {
    tempColor = '#F26D00';
  } else if (colorIndex > 25 && colorIndex <= 30) {
    tempColor = '#E74100';
  } else {
    tempColor = '#E90000';
  }
  return tempColor;
}

export function WDRIconItemSA(props) {
  const item = props.item;
  const tempMin = Object.keys(item.data)[0];
  const tempMax = Object.keys(item.data)[1];
  const icon = Object.keys(item.data)[2];
  // const isDanger = Object.keys(item.data)[3]

  function updateIcon(iconIndex) {
    const icon = 'url("images/wdr/icons/wdr_' + iconIndex + '.gif")';

    return icon;
  }

  function createDangerIcon(isDanger) {
    if (isDanger) {
      return (
        <div
          className='danger-icon'
          style={{backgroundImage: item.ui.dangerIcon}}></div>
      );
    }
  }
  return (
    <AbstractMapItem {...props}>
      <div
        className='wdr-icon-item'
        style={{
          backgroundColor: updateTempColor(item.data.tempMin.value),
          backgroundImage: item.ui.backgroundImage
        }}>
        {/* CREATE TEMP BOX */}
        <div className='map-item-input-wdr-temp-input-wrapper'>
          <div style={{height: '50%'}}>
            <MapInput
              item={item}
              data={{key: tempMin, value: item.data[tempMin].value}}
              callback={props.setValueInMap}
            />
          </div>
          <div style={{height: '50%'}}>
            <MapInput
              item={item}
              data={{key: tempMax, value: item.data[tempMax].value}}
              callback={props.setValueInMap}
            />
          </div>
        </div>
        {/* CREATE ICON BOX */}

        <div
          className='map-item-input-wdr-icon-input-wrapper'
          style={{
            backgroundColor: item.ui.backgroundColor,
            backgroundImage: updateIcon(item.data.icon.value)
            //
          }}>
          <MapInput
            item={item}
            data={{key: icon, value: item.data[icon].value}}
            callback={props.setValueInMap}
          />
        </div>

        {/* CREATE DANGER ICON */}

        {createDangerIcon(item.data.isDanger.value)}

        <div className='danger-checkbox'>
          <input
            type='checkbox'
            checked={item.data.isDanger.value}
            onKeyPress={e => {
              if (e.key === 'Enter' || e.keyCode === 13) {
                props.setValueInMap(item, {
                  isDanger: {value: !e.target.checked}
                });
              }
            }}
            onChange={e =>
              props.setValueInMap(item, {isDanger: {value: e.target.checked}})
            }
          />
        </div>
      </div>
    </AbstractMapItem>
  );
}
